import { connect } from 'react-redux'
import { doToggleRightSidebar } from 'actions/app/doToggleRightSidebar'
import { selectIsRightSidebarCollapsed } from 'selectors/app/selectIsRightSidebarCollapsed'
import withPanelWidthManager from 'components/App/DesktopView/Layout/withPanelWidthManager'
import { DEFAULT_WIDTHS as FOUR_COLUMN_DEFAULT_WIDTHS } from 'components/App/DesktopView/Layout/LayoutSwitcher/ModernView/defaults'
import { DEFAULT_WIDTHS as THREE_COLUMN_DEFAULT_WIDTHS } from 'components/App/DesktopView/Layout/LayoutSwitcher/ClassicView/defaults'
import View from './view'

const select = state => {
  return {
    isRightSidebarCollapsed: selectIsRightSidebarCollapsed(state),
  }
}

const perform = {
  doToggleRightSidebar,
}

const ColumnLayout = connect(select, perform)(View)

export default ColumnLayout

export const ThreeColumnLayout = withPanelWidthManager(
  THREE_COLUMN_DEFAULT_WIDTHS,
  'chat-3-columns-widths'
)(ColumnLayout)

export const FourColumnLayout = withPanelWidthManager(
  FOUR_COLUMN_DEFAULT_WIDTHS,
  'chat-4-columns-widths'
)(ColumnLayout)
